<template>
  <v-row no-gutters justify="center" align="center">
    <div class="rgb-button-wrapper" v-if="rgbView && !isOptos">
      <active-image-button
        btnClass="modal-cta"
        title="Expand left panel"
        image="blue-big-icon.png"
        activeImage="White Icons/white-big-icon.png"
        :active="rgbExpanded"
        @click="$store.commit('setRGBExpanded', true)"/>
      <active-image-button
        btnClass="modal-cta"
        title="Collapse left panel"
        image="blue-small-icon.png"
        activeImage="White Icons/white-small-icon.png"
        :active="!rgbExpanded"
        @click="$store.commit('setRGBExpanded', false)"/>
    </div>
    <span v-if="imgTimestamp" :class="colorClass + ' timestamp'">{{imgTimestamp}}</span>
    <span v-if="imgEye" :class="colorClass + ' current-image-eye'">{{imgEye}}</span>
    <v-col cols="auto" id="fa-caret">
      <v-btn icon class="modal-cta mx-1" @click="$emit('previous')">
        <v-icon>fas fa-caret-left</v-icon>
      </v-btn>
      <index-counter :class="colorClass" :index="index" :count="count" />
      <v-btn icon class="modal-cta mx-1" @click="$emit('next')">
        <v-icon>fas fa-caret-right</v-icon>
      </v-btn>
    </v-col>
    <play-pause-button :isPlaying="isPlaying" @play="$emit('play')" @pause="$emit('pause')" />
    <select-with-button
      :value="playRate"
      @change="$emit('setPlayRate', $event)"
      :items="playRates"
      :icon-button="true"
      class="toolbar-select"/>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import selectWithButton from "../../controls/SelectWithButton";
import activeImageButton from "../../controls/ActiveImageButton";
import indexCounter from "../IndexCounter";
import playPauseButton from "../../controls/PlayPauseButton";
import { PLAY_RATES } from "../../../config/config";
export default {
  name: "playbackControls",
  components: { indexCounter, selectWithButton, activeImageButton, playPauseButton },
  props: {
    index: Number,
    count: Number,
    isPlaying: Boolean,
    playRate: String
  },
  data() {
    return { playRates: PLAY_RATES };
  },
  computed: {
    ...mapGetters(["imgEye", "imgTimestamp", "rgbView", "isOptos", "rgbExpanded"]),
  }
};
</script>
